import getSessionId from '../../getSessionId';
import {NETWORK_REQUEST_BEGUN, NETWORK_REQUEST_FINISHED} from '../actions/action-types';
import Track from '../utils/tracking';
import {redirect} from './redirect';

export function networkRequestBegun() {
  return {
    type: NETWORK_REQUEST_BEGUN,
  };
}

export function networkRequestFinished() {
  return {
    type: NETWORK_REQUEST_FINISHED,
  };
}

function url(path) {
  if (window.testEnv) {
    return window.testEnv.HOST + path;
  }
  return path;
}

const validateCookie = () => Promise.resolve()
  .then(() => {
    const sessionCookie = getSessionId();
    if (!sessionCookie) {
      redirect.toRedirectPage();
      throw new Error('session expired');
    } else {
      return sessionCookie;
    }
  });

const doAPIRequest = (path, body, type = 'application/json; charset=utf-8', method = 'POST') => (
  validateCookie()
    .then((sessionCookie) => {
      const endpoint = url(`/checkout-api${path}`);
      return fetch(endpoint, {
        body,
        method,
        mode: 'cors',
        cache: 'no-cache',
        credentials: 'same-origin', // To automatically include cookies with the request
        headers: {
          'Content-Type': type,
          sessionId: sessionCookie,
          'x-thg-client': 'checkout-web-js',
        },
      })
        .then(response => response.json()
          .catch(() => ({}))
          .then((json) => {
            const responseMessage = msg => ({status: response.status, msg});
            if (response.ok) return responseMessage(json);
            throw responseMessage(json.text);
          }));
    })
);

const doNetworkRequest = (endpoint, data, type = 'application/json; charset=utf-8', method = 'POST') => (dispatch) => {
  dispatch(networkRequestBegun());
  return doAPIRequest(endpoint, data, type, method)
    .catch((error) => {
      Track.error(`An error occurred whilst sending the request - status: ${error?.status}, msg: ${error?.msg} for endpoint: ${endpoint}`);
    })
    .finally(() => dispatch(networkRequestFinished()));
};

const API = {
  handleWeChatSessionUpdate(state) {
    return doAPIRequest(`/v2/return-from-hosted/wechatpay-update?state=${state}`, JSON.stringify({}));
  },
  handleWeChatAuthorizationUpdate(code) {
    const WeChatPayAppReturnJson = {authorisationCode: code};
    return doAPIRequest('/v2/return-from-hosted/wechatpay', JSON.stringify(WeChatPayAppReturnJson));
  },
  doAPIRequest,
  doNetworkRequest,
  networkRequestFinished,
  networkRequestBegun,
};

export default API;
